import { BaseComponent } from "./base";

export class Launcher extends BaseComponent {
  private onClick: () => void;
  private badge?: HTMLElement;

  constructor(onClick: () => void) {
    super();
    this.onClick = onClick;
    this.element = this.create();
    this.initEvents();
  }

  protected create(): HTMLElement {
    const el = document.createElement("button");
    el.className = "ac-launcher";
    el.setAttribute("aria-label", "Open chat");
    el.setAttribute("aria-expanded", "false");

    el.innerHTML = `
      <span class="ac-launcher-icon ac-launcher-open">
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
        </svg>
      </span>
      <span class="ac-launcher-icon ac-launcher-close">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </span>
    `;

    this.badge = document.createElement("span");
    this.badge.className = "ac-launcher-badge";
    this.badge.hidden = true;
    el.appendChild(this.badge);

    return el;
  }

  private initEvents(): void {
    this.element.addEventListener("click", () => this.onClick());
  }

  public setActive(active: boolean): void {
    this.element.classList.toggle("ac-launcher-active", active);
    this.element.setAttribute("aria-expanded", String(active));
    if (active) this.clearBadge();
  }

  public showBadge(count?: number): void {
    if (!this.badge) return;
    this.badge.hidden = false;
    this.badge.textContent = count !== undefined && count > 0 ? String(Math.min(count, 99)) : "";
  }

  public clearBadge(): void {
    if (!this.badge) return;
    this.badge.hidden = true;
    this.badge.textContent = "";
  }
}
